import React, { useContext, useEffect, useRef, useState } from 'react'
import Vtabs from '../../../components/tabs/vtabs'
import BusinessownersUM from './businessowners-um/businessowners'
import Buttons from '../../../components/buttons/buttons'
import ActionButton from '../../../components/buttons/newbutton'
import InputSearch from '../../../utils/controls/input-search'
import SpPeoplePicker from 'react-sp-people-picker'
import Tooltip from '../../../components/tooltip/tooltips'
import Popups from '../../../components/popup/popupwithposition'
import { PopupCloseContext, UserInitalValue } from '../../../shared/contexts/popupclose-context'

export const UserManagement = (props:any) => {
    const [userCount, setUserCount] = useState(0)

    const handleUsersFetched = (count: number) => {
        setUserCount(count)
    }

    const tableitems = [
      {
        tabtitle: `Owners (${userCount.toString().padStart(2, '0')})`,
        is_active: 'true',
        content : <BusinessownersUM onUsersFetched={handleUsersFetched} />
      }
    ]

    const tabsminheight = (tableitems.length) * 44

    return (
        <div className='container'>
            <div className='row m-0'>
              <div className='mt-0 p-0 tabscontent-height' style={{ minHeight: tabsminheight + 16 }}>
                <Vtabs
                    key={userCount}
                    items={tableitems}
                    page='settings'
                    className='w-100 h-100'
                    mainTabsclass='card-body v-tabs h-100 p-relative pt-xl-5 pt-8 ps-2'
                    tablistclassName='w-100'
                    vtabscontentclassName='w-100 ps-2 pt-0 m-1'
                    anchorclass='title-color13 font-14 segoeui-regular justify-content-center justify-content-xl-start'
                    tabsul='w-100 min-w-xl-200 max-w-xl-200 h-fitcontent vtabs-maxheight bordered2 border-radius0 whitebg p-1'
                />
                {/* ======================================================= */}
              </div>
            </div>
        </div>
    )
}